<template>

  <v-card
    color="white"
    outlined
  >
    <v-img
      @click.stop="$emit('click')"
      @dblclick.stop="$emit('dblclick')"
      class="white--text align-center justify-center img-bg pointer"
      height="200px"
      contain
    >
      <template v-slot:placeholder>
        <v-row
          class="align-center justify-center fill-height ma-0"
        >
          <v-icon
            size="130"
          >{{ thumb }}</v-icon>
        </v-row>
      </template>
    </v-img>

    <v-card-actions class="card-actions">
      <v-icon
        color="defaultIconColor"
      >{{ icon }}</v-icon>

      <v-tooltip open-delay="1000" bottom>
        <template v-slot:activator="{ on, attrs }">

          <v-card-subtitle
            v-bind="attrs"
            v-on="on"
            class="custom-subtitle"
          >{{ agent.application_instance_title }}</v-card-subtitle>

        </template>
        <span>{{ agent.application_instance_title }}</span>
      </v-tooltip>

    </v-card-actions>
  </v-card>

</template>

<style scoped>
  .pointer {
    cursor: pointer;
  }

  .img-bg {
    background-color: #DADCE0;
  }

  .v-card {
    border-color: #DADCE0 !important;
  }

  .card-actions {
    padding: 1px 8px 1px 8px;
  }

  .custom-subtitle {
    font-weight: 500;
    color: rgb(60, 64, 67) !important;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 16px 12px !important;
  }
</style>

<script>

export default {
  name: "AgentCard",

  props: {
    agent: {
      type: Object,
      default: () => {}
    }
  },

  computed: {
    thumb() {
      return this.agent.config.thumb || 'mdi-robot'
    },

    icon() {
      return this.agent.config.icon || 'mdi-robot'
    },
  },

  methods: {
    parseApplicationConfig(string) {
      try {
        return JSON.parse(string)
      } catch (e) {
        return {}
      }
    },
  },
}

</script>
